import React from "react";
import StartStep from "../../components/StartStep/StartStep";
import GreyCard from "../../components/GreyCard/GreyCard";
import Row from "react-bootstrap/Row";
import {Button, Col, ProgressBar} from "react-bootstrap";
import Container from "react-bootstrap/Container";

const AboutUs = () => {
    return (
        <div>
            <StartStep>
                <h1>Оборудовать рабочее место </h1>
            </StartStep>
            <GreyCard>
                <p>
                    В поисковой строке Единого личного кабинета наберите "Выдача в постоянное пользование".
                    Так Вы сможете узнать, как получить компьютер, МФУ и телефон.
                </p>
                <br/><br/>
                <p><a href="https://hrd.hse.ru/mirror/pubs/share/482721316.pdf">Выдача оборудования</a></p>
            </GreyCard>

            <br/><br/>

            <Container>
                <Row className="justify-content-md-center">
                    <Col md={2}>
                        <Button variant="outline-primary" style={{width: "100%"}} href="/step5">Назад</Button>{' '}
                    </Col>
                    <Col md={1}></Col>
                    <Col md={6} style={{ textAlign: "center", paddingTop: "6px"}}>
                        <ProgressBar now={54}/>
                        <span>Шаг 6 из 11</span>
                    </Col>
                    <Col md={1}></Col>
                    <Col md={2}>
                        <Button variant="outline-primary" style={{width: "100%"}} href="/step7">Вперед</Button>{' '}
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default AboutUs;